import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Tooltip, message } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import { validateEmail, validateSenha, checkFormIsValid, CPFValido } from "../utils/Validator";
import { maskCPF, maskTelefone } from "../utils/Masker";
import axios from "axios";
import GrupoUsuarioFrame from './GrupoUsuarioFrame';

const { Item: ItemForm } = Form;

export const OPCOES_COMBO_PRECO_DUPLICAR = [
  { key: 'M', label: 'MANTER PREÇO' },
  { key: 'C', label: 'RECALCULAR' },
  { key: 'P', label: 'PERGUNTAR' },
]

export const OPCOES_COMBO_TIPO_IMPRESSAO_PEDIDO = [
  { key: 'A4', label: 'A4' },
  { key: 'CUP', label: 'CUPOM' },
]

export const OPCOES_COMBO_TIPO_FRETE = [
  { key: 'XXX', label: 'ESCOLHER FRETE' },
  { key: 'CIF', label: 'FRETE EMPRESA' },
  { key: 'FOB', label: 'FRETE CLIENTE' },
]

export const OPCOES_COMBO_TIPO_CALCULO_FRETE = [
  { key: 'SEM', label: 'SEM FRETE' },
  { key: 'MAN', label: 'INFORMA FRETE MANUALMENTE' },
  { key: 'CSA', label: 'CALCULA FRETE SEM PODER ALTERAR' },
  { key: 'CPA', label: 'CALCULA FRETE PODENDO ALTERAR' },
]

export const OPCOES_COMBO_CLIENTES_USUARIO = [
  { key: 'TOD', label: 'TODOS OS CLIENTES DA EMPRESA' },
  { key: 'VEN', label: 'SOMENTE CLIENTES VINCULADOS AO VENDEDOR' },
  { key: 'AVU', label: 'CLIENTES DO VENDEDOR + CLIENTES AVULSOS' },
]

export const OPCOES_COMBO_TIPO_PEDIDO_PADRAO = [
  { key: 'P', label: 'PEDIDO' },
  { key: 'O', label: 'ORÇAMENTO' },
  { key: 'B', label: 'BONIFICAÇÃO' },
]

export const OPCOES_COMBO_TIPO_ACESSO = [
  { key: 'T', label: 'TODAS PLATAFORMAS' },
  { key: 'A', label: 'SOMENTE NO APP' },
  { key: 'W', label: 'SOMENTE NO WEB' },
]




export default class UsuarioForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      registro: {},
      listaTabelaDescontos: [],
      listaLinhasProducao: [],
    }
  }

  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado,
      }, () => {
        this.buscaTabelaDesconto();
        this.buscaLinhaProducao();
      });
    }
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    const { registro } = this.state;
    registro[id] = value;

    this.setState({
      [id]: value
    });
  };

  onChangeGrupo = event => {
    const { registro } = this.state;
    registro['ue_grupo'] = event.ue_grupo;
    this.setState(event);
  }

  onOK = () => {
    const { registro } = this.state;

    const PFJ = registro.usu_cpf ? registro.usu_cpf.replace(/[^\d]/g, '') : '';
    if (!CPFValido(PFJ)) {
      Modal.warning({
        title: 'Aviso!',
        content: 'CPF Inválido',
      });
      return;
    }

    if ((!this.state.registro.usu_nome) || (this.state.registro.usu_nome === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Nome' });
      return;
    }

    if ((!this.state.registro.usu_email) || (this.state.registro.usu_email === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Email' });
      return;
    }

    if ((!this.state.registro.usu_senha) || (this.state.registro.usu_senha === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Senha' });
      return;
    }

    if ((!this.state.registro.ue_grupo) || (this.state.registro.ue_grupo.key === '0') || (this.state.registro.ue_grupo.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Grupo', });
      return;
    }


    const reg = {
      ...registro,

      usu_cpf: registro.usu_cpf.replace(/[^0-9]/g, ''),
      ue_grupo: registro.ue_grupo.key,

      ue_duplicar_pedido: registro.check_duplicar ? registro.opcao_duplicar.key : 'N',

      ue_forca_sinc_cad: (registro.ue_forca_sinc_cad_flag ? 'S' : 'N') + (registro.ue_forca_sinc_cad_dias ? registro.ue_forca_sinc_cad_dias : '0'),

      ue_clientes_vendedor: registro.ue_clientes_vendedor && registro.ue_clientes_vendedor.key ? registro.ue_clientes_vendedor.key : '',
      ue_tipo_impressao_pedido: registro.ue_tipo_impressao_pedido && registro.ue_tipo_impressao_pedido.key ? registro.ue_tipo_impressao_pedido.key : '',
      ue_tipo_frete: registro.ue_tipo_frete && registro.ue_tipo_frete.key === 'XXX' ? '' : registro.ue_tipo_frete.key,
      ue_tipo_pedido_padrao: registro.ue_tipo_pedido_padrao && registro.ue_tipo_pedido_padrao.key ? registro.ue_tipo_pedido_padrao.key : '',
      ue_plataforma_acesso: registro.ue_plataforma_acesso && registro.ue_plataforma_acesso.key ? registro.ue_plataforma_acesso.key : '',
      ue_tipo_calculo_frete: registro.ue_tipo_calculo_frete && registro.ue_tipo_calculo_frete.key ? registro.ue_tipo_calculo_frete.key : '',
      ue_cod_tabela_desconto: registro.ue_cod_tabela_desconto && registro.ue_cod_tabela_desconto.key ? registro.ue_cod_tabela_desconto.key : '',
      ue_linha_producao: registro.ue_linha_producao && registro.ue_linha_producao.key ? registro.ue_linha_producao.key : '',

      ue_bloq_venda_cli_dev: registro.ue_bloq_venda_cli_dev ? 1 : 0,
      ue_bloq_venda_sem_est: registro.ue_bloq_venda_sem_est ? 1 : 0,
      ue_avisar_venda_sem_est: registro.ue_avisar_venda_sem_est ? 1 : 0,
      ue_flag_bonificacao: registro.ue_flag_bonificacao ? 1 : 0,
      ue_flag_mostrar_tabelas: registro.ue_flag_mostrar_tabelas ? 1 : 0,
      ue_flag_desconto_tab1: registro.ue_flag_desconto_tab1 ? 1 : 0,
      ue_flag_desconto_tab2: registro.ue_flag_desconto_tab2 ? 1 : 0,
      ue_flag_permite_alt_preco_uni: registro.ue_flag_permite_alt_preco_uni ? 1 : 0,
      ue_flag_tabela_preco_minimo: registro.ue_flag_tabela_preco_minimo ? 1 : 0,
      ue_flag_ultimo_preco_vendido: registro.ue_flag_ultimo_preco_vendido ? 1 : 0,

    };

    // console.log('onOK: ', reg)

    this.props.onSalvarClick(reg);
  };


  buscaTabelaDesconto = (value) => {
    this.setState({ listaTabelaDescontos: [] })
    const { ue_cod_tabela_desconto } = this.state.registro;
    axios.get('/tabelaDescontos/listaTabelas', {
    }).then(response => {
      const { data } = response;

      const listaTabelaDescontos = data.map(regList => {
        return {
          key: regList.td_idf,
          label: regList.td_descricao
        }
      });

      listaTabelaDescontos.unshift({
        key: 0,
        label: "SEM TABELA",
      });

      let desconto = ue_cod_tabela_desconto;
      if (!ue_cod_tabela_desconto) {
        desconto = listaTabelaDescontos[0].key;
      }

      this.setState({
        listaTabelaDescontos,
        ue_cod_tabela_desconto: desconto,
      })

    }).catch(error => {
      console.error(error.response);
    })
  }


  buscaLinhaProducao = (value) => {
    this.setState({ listaLinhasProducao: [] })
    const { ue_linha_producao } = this.state.registro;
    axios.get('/linhaProducao/lista', {
    }).then(response => {
      const { data } = response;

      const listaLinhasProducao = data.map(regList => {
        return {
          key: regList.lp_idf,
          label: regList.lp_descricao
        }
      });

      listaLinhasProducao.unshift({
        key: 0,
        label: "SEM LINHA DE PRODUÇÃO",
      });

      let desconto = ue_linha_producao;
      if (!ue_linha_producao) {
        desconto = listaLinhasProducao[0].key;
      }

      this.setState({
        listaLinhasProducao,
        ue_linha_producao: desconto,
      })

    }).catch(error => {
      console.error(error.response);
    })
  }



  onRedefinirSenha = () => {
    this.setState({
      salvando: true,
    })

    axios.put(`/usuarios/updateSenha/${this.state.registro.usu_cpf.replace(/[^0-9]/g, '')}`, {
      senha: '123456',
    })
      .then(response => {
        this.setState({
          salvando: false,
        });
        message.success('Senha Redefinida com Sucesso (123456)');
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          salvando: false,
        })
        Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
      })

  };










  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { listaTabelaDescontos, listaLinhasProducao } = this.state;
    const { usu_cpf, usu_nome, usu_email, usu_telefone, usu_senha, ue_vendedor, ue_cod_vendedor, ue_perc_comissao, ue_grupo,
      ue_flag_mostrar_tabelas, ue_flag_desconto_tab1, ue_perc_desconto_tab1, ue_flag_desconto_tab2, ue_perc_desconto_tab2,
      ue_tabela_padrao, ue_flag_permite_alt_preco_uni, ue_bloq_venda_cli_dev, ue_bloq_venda_sem_est, ue_avisar_venda_sem_est, ue_flag_bonificacao,
      ue_flag_ultimo_preco_vendido, ue_flag_tabela_preco_minimo, ue_forca_sinc_cad_flag, ue_forca_sinc_cad_dias, check_duplicar, opcao_duplicar, ue_cod_tabela_desconto,
      ue_linha_producao, ue_tipo_impressao_pedido, ue_tipo_frete, ue_tipo_pedido_padrao, ue_plataforma_acesso, ue_tipo_calculo_frete, ue_clientes_vendedor,
      novoReg } = this.state.registro;

    // console.log('UsuarioForm: State: ', this.state)

    return (
      <Modal
        title={novoReg ? "Cadastro de Usuário" : "Edição de Usuário"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"60%"}
        style={{ top: 30 }}
      >
        <Form>
          <Row>


            <Col xs={24} sm={12} style={{ paddingRight: 20, }}>
              <span>CPF</span>
              <InputForm
                type="text"
                id="usu_cpf"
                ref="usu_cpf"
                value={usu_cpf}
                masker={maskCPF}
                onChange={this.onChange}
                disabled={novoReg ? false : true}
              />
            </Col>

            <Col xs={24} sm={12} style={{}}>
              <span>Nome</span>
              <InputForm
                type="text"
                id="usu_nome"
                ref="usu_nome"
                value={usu_nome}
                validator={value => Boolean(value)}
                onChange={this.onChange}
              />
            </Col>

            <Col xs={24} sm={12} style={{ paddingRight: 20, marginTop: -20 }}>
              <span>Email</span>
              <InputForm
                type="email"
                id="usu_email"
                ref="usu_email"
                value={usu_email}
                validator={validateEmail}
                onChange={this.onChange}
              />
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -20 }}>
              <span>Telefone</span>
              <InputForm
                id="usu_telefone"
                ref="usu_telefone"
                value={usu_telefone}
                maxLength={15}
                masker={maskTelefone}
                onChange={this.onChange}
                validator={value => Boolean(value)}
              />
            </Col>

            <Col xs={24} sm={4} style={{ padding: 0, margin: 0 }} className="campoCheckBox">
              <InputForm
                type="checkbox"
                id="ue_vendedor"
                ref="ue_vendedor"
                onChange={this.onChange}
                value={ue_vendedor}
              >
                Vendedor
              </InputForm>
            </Col>

            <Col xs={24} sm={4} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Código Vendedor</span>
              <InputForm
                type="text"
                id="ue_cod_vendedor"
                ref="ue_cod_vendedor"
                value={ue_cod_vendedor}
                validator={value => Boolean(value)}
                onChange={this.onChange}
                disabled={ue_vendedor ? false : true}
              />
            </Col>

            <Col xs={24} sm={4} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Comissão %</span>
              <InputForm
                type="number"
                id="ue_perc_comissao"
                ref="ue_perc_comissao"
                value={ue_perc_comissao}
                onChange={this.onChange}
              />
            </Col>


            <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
              <GrupoUsuarioFrame
                label="Grupo Usuário"
                id="ue_grupo"
                value={ue_grupo}
                width={"100%"}
                onChange={this.onChangeGrupo}
              />
            </Col>

            {novoReg ? (
              <Col xs={24} sm={6} style={{ marginTop: -20 }}>
                <span>Senha</span>
                <InputForm
                  type="password"
                  id="usu_senha"
                  ref="usu_senha"
                  value={usu_senha}
                  minLength={6}
                  maxLength={15}
                  validator={validateSenha}
                  onChange={this.onChange}
                />
              </Col>
            ) : (
              <Col xs={24} sm={6} style={{ marginTop: 3 }}>
                <Button
                  htmlType="button"
                  loading={carregando}
                  onClick={this.onRedefinirSenha}
                >
                  Redefinir Senha
                </Button>
              </Col>
            )}

            <Col xs={24} sm={12} style={{ marginTop: -20 }} className="campoCheckBox">
              <InputForm
                type="checkbox"
                id="ue_flag_mostrar_tabelas"
                ref="ue_flag_mostrar_tabelas"
                onChange={this.onChange}
                value={ue_flag_mostrar_tabelas}
              >
                Mostrar Tabelas de Preço
              </InputForm>
            </Col>

            <Col xs={24} sm={12} style={{ paddingRight: 20 }}>
              <span>Tabela Padrão</span>
              <InputForm
                type="text"
                id="ue_tabela_padrao"
                ref="ue_tabela_padrao"
                value={ue_tabela_padrao}
                minLength={1}
                maxLength={1}
                validator={value => Boolean(value)}
                onChange={this.onChange}
              />
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -20 }} className="campoCheckBox">
              <InputForm
                type="checkbox"
                id="ue_flag_desconto_tab1"
                ref="ue_flag_desconto_tab1"
                onChange={this.onChange}
                value={ue_flag_desconto_tab1}
              >
                Desconto Máximo Tabela 1
              </InputForm>
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -20 }}>
              <span>Desconto %</span>
              <InputForm
                type="number"
                id="ue_perc_desconto_tab1"
                ref="ue_perc_desconto_tab1"
                value={ue_perc_desconto_tab1}
                onChange={this.onChange}
                disabled={ue_flag_desconto_tab1 ? false : true}
              />
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -20 }} className="campoCheckBox">
              <InputForm
                type="checkbox"
                id="ue_flag_desconto_tab2"
                ref="ue_flag_desconto_tab2"
                onChange={this.onChange}
                value={ue_flag_desconto_tab2}
              >
                Desconto Máximo Tabela 2
              </InputForm>
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -20 }}>
              <span>Desconto %</span>
              <InputForm
                type="number"
                id="ue_perc_desconto_tab2"
                ref="ue_perc_desconto_tab2"
                value={ue_perc_desconto_tab2}
                onChange={this.onChange}
                disabled={ue_flag_desconto_tab2 ? false : true}
              />
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -20 }} className="campoCheckBox">
              <InputForm
                type="checkbox"
                id="check_duplicar"
                ref="check_duplicar"
                onChange={this.onChange}
                value={check_duplicar}
              >
                Duplicar Pedido
              </InputForm>
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -20 }}>
              <span>Opção para Preço ao Duplicar</span>
              <InputForm
                type="select"
                id="opcao_duplicar"
                ref="opcao_duplicar"
                value={opcao_duplicar}
                placeholder="Selecione"
                onChange={this.onChange}
                data={OPCOES_COMBO_PRECO_DUPLICAR}
                validator={value => Boolean(value)}
                style={{ width: "100%" }}
                disabled={check_duplicar ? false : true}
              />
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -20 }} className="campoCheckBox">
              <InputForm
                type="checkbox"
                id="ue_forca_sinc_cad_flag"
                ref="ue_forca_sinc_cad_flag"
                onChange={this.onChange}
                value={ue_forca_sinc_cad_flag}
              >
                Forçar usuário sincronizar dados no dispositivo
              </InputForm>
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -20 }}>
              <span>Dias para Atualizar os dados no dispositivo</span>
              <InputForm
                type="text"
                id="ue_forca_sinc_cad_dias"
                ref="ue_forca_sinc_cad_dias"
                value={ue_forca_sinc_cad_dias}
                minLength={1}
                maxLength={3}
                validator={value => Boolean(value)}
                onChange={this.onChange}
              />
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -20 }}>
              <InputForm
                type="checkbox"
                id="ue_flag_permite_alt_preco_uni"
                ref="ue_flag_permite_alt_preco_uni"
                onChange={this.onChange}
                value={ue_flag_permite_alt_preco_uni}
              >
                Permite Alterar o Preço Unitário
              </InputForm>
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -20 }}>
              <InputForm
                type="checkbox"
                id="ue_flag_tabela_preco_minimo"
                ref="ue_flag_tabela_preco_minimo"
                onChange={this.onChange}
                value={ue_flag_tabela_preco_minimo}
              >
                Bloquear vendas menor que valor mínimo
              </InputForm>
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -20 }}>
              <InputForm
                type="checkbox"
                id="ue_bloq_venda_cli_dev"
                ref="ue_bloq_venda_cli_dev"
                onChange={this.onChange}
                value={ue_bloq_venda_cli_dev}
              >
                Bloquear Venda de Clientes Com Dívida
              </InputForm>
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -20 }}>
              <InputForm
                type="checkbox"
                id="ue_bloq_venda_sem_est"
                ref="ue_bloq_venda_sem_est"
                onChange={this.onChange}
                value={ue_bloq_venda_sem_est}
              >
                Bloquear Venda sem Estoque
              </InputForm>
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -20 }}>
              <InputForm
                type="checkbox"
                id="ue_avisar_venda_sem_est"
                ref="ue_avisar_venda_sem_est"
                onChange={this.onChange}
                value={ue_avisar_venda_sem_est}
              >
                Avisar Venda sem Estoque
              </InputForm>
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -20 }}>
              <InputForm
                type="checkbox"
                id="ue_flag_bonificacao"
                ref="ue_flag_bonificacao"
                onChange={this.onChange}
                value={ue_flag_bonificacao}
              >
                Pode fazer venda Bonificação
              </InputForm>
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -20 }}>
              <Tooltip title="Ex: Se o vendedor vendeu um produto 10% acima do preço para um cliente, na proxima venda se o preço subiu, tem que vendar 10% acima do novo preço, para vender abaixo disso, precisa da senha. TAG que usa." placement="topLeft">
                <InputForm
                  type="checkbox"
                  id="ue_flag_ultimo_preco_vendido"
                  ref="ue_flag_ultimo_preco_vendido"
                  onChange={this.onChange}
                  value={ue_flag_ultimo_preco_vendido}
                >
                  Controla último preço comercializado
                </InputForm>
              </Tooltip>
            </Col>

            {/* <Col xs={24} sm={12} style={{ marginTop: -20 }}>
              <InputForm
                type="checkbox"
                id=""
                ref=""
                onChange={this.onChange}
                value={0}
                disabled={true}
              >
              </InputForm>
            </Col> */}

            <Col xs={24} sm={12} style={{ marginTop: -20 }}>
              <span>Importação dos Clientes para o Vendedor</span>
              <InputForm
                type="select"
                id="ue_clientes_vendedor"
                ref="ue_clientes_vendedor"
                value={ue_clientes_vendedor}
                placeholder="Selecione"
                onChange={this.onChange}
                data={OPCOES_COMBO_CLIENTES_USUARIO}
                validator={value => Boolean(value)}
                style={{ width: "100%" }}
              />
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Modelo de Impressão do Pedido</span>
              <InputForm
                type="select"
                id="ue_tipo_impressao_pedido"
                ref="ue_tipo_impressao_pedido"
                value={ue_tipo_impressao_pedido}
                placeholder="Selecione"
                onChange={this.onChange}
                data={OPCOES_COMBO_TIPO_IMPRESSAO_PEDIDO}
                validator={value => Boolean(value)}
                style={{ width: "100%" }}
              />
            </Col>


            <Col xs={24} sm={12} style={{ marginTop: -20 }}>
              <span>Tabela de Desconto</span>
              <InputForm
                type="select"
                id="ue_cod_tabela_desconto"
                ref="ue_cod_tabela_desconto"
                value={ue_cod_tabela_desconto}
                placeholder="Selecione"
                onChange={this.onChange}
                data={listaTabelaDescontos}
                validator={value => Boolean(value)}
                style={{ width: "100%" }}
              />
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Tipo Frete Padrão</span>
              <InputForm
                type="select"
                id="ue_tipo_frete"
                ref="ue_tipo_frete"
                value={ue_tipo_frete}
                placeholder="Selecione"
                onChange={this.onChange}
                data={OPCOES_COMBO_TIPO_FRETE}
                validator={value => Boolean(value)}
                style={{ width: "100%" }}
              />
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -20 }}>
              <span>Tipo de Cálculo de Frete</span>
              <InputForm
                type="select"
                id="ue_tipo_calculo_frete"
                ref="ue_tipo_calculo_frete"
                value={ue_tipo_calculo_frete}
                placeholder="Selecione"
                onChange={this.onChange}
                data={OPCOES_COMBO_TIPO_CALCULO_FRETE}
                validator={value => Boolean(value)}
                style={{ width: "100%" }}
              />
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Tipo de Pedido Padrão</span>
              <InputForm
                type="select"
                id="ue_tipo_pedido_padrao"
                ref="ue_tipo_pedido_padrao"
                value={ue_tipo_pedido_padrao}
                placeholder="Selecione"
                onChange={this.onChange}
                data={OPCOES_COMBO_TIPO_PEDIDO_PADRAO}
                validator={value => Boolean(value)}
                style={{ width: "100%" }}
              />
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -20 }}>
              <span>Tipo de Acessos</span>
              <InputForm
                type="select"
                id="ue_plataforma_acesso"
                ref="ue_plataforma_acesso"
                value={ue_plataforma_acesso}
                placeholder="Selecione"
                onChange={this.onChange}
                data={OPCOES_COMBO_TIPO_ACESSO}
                validator={value => Boolean(value)}
                style={{ width: "100%" }}
              />
            </Col>

            <Col xs={24} sm={12} style={{ marginTop: -20, paddingRight: 20 }}>
              <span>Linha de Produção</span>
              <InputForm
                type="select"
                id="ue_linha_producao"
                ref="ue_linha_producao"
                value={ue_linha_producao}
                placeholder="Selecione"
                onChange={this.onChange}
                data={listaLinhasProducao}
                validator={value => Boolean(value)}
                style={{ width: "100%" }}
              />
            </Col>

          </Row>

          <ItemForm>
            <Row>
              <Col xs={24}>
                <Button
                  htmlType="button"
                  loading={carregando}
                  onClick={this.onOK}
                  className="botoesModalForm"
                >
                  Salvar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="botoesModalFecharForm"
                >
                  Cancelar
                </Button>
              </Col>
            </Row>
          </ItemForm>

        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/UsuarioForm.js